import React, { useState, useEffect } from "react";
import BookForm from "./BookForm";
import { AiFillInfoCircle, AiOutlineArrowLeft } from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { FiChevronDown } from "react-icons/fi";
import TopNav from "../../TopNav/TopNav";

// import ImagingHeader from "../ImagingHeader";
import ImagingNewHeader from "../ImagingNewHeader";

import ImagingFooter from "../ImagingFooter";

import Loader from "../../Loader/Loader";
import { Scroll } from "../../Scroll function/scroll";
import {
  getAllAddress,
  getCartDetails,
  getAreaPincode,
  postNewAddress,
  editAddressForm,
  deleteAddress,
  CreateBooking,
} from "../../../Redux/Actions";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { BackToscreenIcon, DesktopBack } from "../../Cart/Cart";

function PatientAddress(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = props.location.pathname;
  console.log("pathname", location);
  const [editId, setEditId] = useState("");
  //
  const [coupnDis, setCoupn] = useState(props.location.state ?? 0);
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const currentcity = citySelected.citySelect;
  //const get address details
  useEffect(() => {
    const datekey = JSON.parse(localStorage.getItem("user"));
    console.log(datekey);
    // const token = datekey.token;
    dispatch(getCartDetails(datekey.token, currentcity && currentcity));
    dispatch(getAllAddress(datekey.token));
  }, []);

  //post data response

  //pincode state
  const [areApin, setpin] = useState("");
  const addressData = useSelector((state) => state.addressReducer);

  const { loading, addresss } = addressData;

  const cartDetails = useSelector((state) => state.CartReducer);

  const { loading: cartLoading, cartDetails: cartdata } = cartDetails;

  //pincode details
  const pincodeDetails = useSelector((state) => state.areaPincodeReducer);

  const { loading: pincodeLoading, areaPincode } = pincodeDetails;

  console.log("pincode details", pincodeDetails);
  //toggleer
  const [showAddressForm, setShowAddressForm] = useState(false);

  // useEffect(() => {
  //   dispatch(getAreaPincode());
  // }, []);

  //
  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;

    dispatch(getCartDetails(token, currentcity && currentcity));
  }, []);
  //const pincode handler
  const handelPincode = (e) => {
    setpin(e.target.value);
    setPinList(true);
  };

  const [pinList, setPinList] = useState(false);
  const [finalPin, setfinalPin] = useState("");

  const handelPincodeList = (values) => {
    setpin(values.pincode);
    setfinalPin(values.id);
    setPinList(false);
    console.log("pincode data", values);
    let detailsObject = JSON.parse(localStorage.getItem("patientDetail"));
    detailsObject.area = values;
    console.log("new object", detailsObject);
    localStorage.setItem("patientDetail", JSON.stringify(detailsObject));
  };

  var deliveryCharges = 0;

  const [details, setDetails] = useState([]);

  useEffect(() => {
    if (
      cartDetails &&
      cartDetails.cartDetails &&
      cartDetails.cartDetails[0] &&
      cartDetails.cartDetails[0].product
    ) {
      setDetails(cartDetails.cartDetails[0].product);
    }
  }, [cartDetails && cartDetails]);

  if (details !== "") {
    var sum = details.reduce((currentSum, nextObject) => {
      // Note that you need to coerce points_earned
      // to a Number or it will simply concatenate the strings
      return (currentSum += nextObject?.package?.package_city_prices
        ? nextObject?.package?.package_city_prices?.package_price
        : nextObject?.package?.package_price);

      // 0 is your initial value used by currentSum in
      // the first iteration
    }, 0);

    console.log("this is some", sum);
  }
  if (details !== "") {
    var offerSum = 0;
    let numOfTrue = 0;
    // console.log(details, "Lenght Detail obj")
    details.map((item) => {
      if (item?.package?.is_addon) {
        numOfTrue += 1;
      }
    });

    if (details.length == numOfTrue) {
      console.log("all are add on packages");
      offerSum = details.reduce((currentOfferSum, nextObject) => {
        currentOfferSum += nextObject?.package?.package_city_prices
          ? nextObject?.package?.package_city_prices?.offer_price
          : nextObject?.package?.offer_price;
        console.log(
          nextObject?.package?.package_city_prices
            ? nextObject?.package?.package_city_prices?.offer_price
            : nextObject?.package?.offer_price,
          "Now only offer price"
        );
        return currentOfferSum;
      }, 0);
    } else {
      // props.setAllAddonFalse()
      console.log("all are not add on");
      offerSum = details.reduce((currentOfferSum, nextObject) => {
        if (nextObject?.package?.is_addon) {
          currentOfferSum += nextObject?.package?.addon_price;
          console.log(
            nextObject?.package?.addon_price,
            " Add on price package found"
          );
        } else if (!nextObject?.package?.is_addon) {
          currentOfferSum += nextObject?.package?.package_city_prices
            ? nextObject?.package?.package_city_prices?.offer_price
            : nextObject?.package?.offer_price;
          console.log(
            nextObject?.package?.package_city_prices
              ? nextObject?.package?.package_city_prices?.offer_price
              : nextObject?.package?.offer_price,
            "Offer price/pack citywise package found"
          );
        }
        return currentOfferSum;
      }, 0);
    }

    if (offerSum < 99) {
      deliveryCharges = 200;
    }
  }
  if (details !== "") {
    var discountSum = sum - offerSum;
    var discountPercent = Math.floor((discountSum / sum) * 100);
  }
  //adding address

  const [newName, setNewName] = useState("");
  const [Phonenum, setPhonenum] = useState("");
  const [house_Numbeer, setHouseNumber] = useState("");
  const [street_name, setstreet_name] = useState("");
  const [booking_for, setbooking_for] = useState("");
  const [deleteid, setDeleteId] = useState("");
  const [showDetails, setShowDetails] = useState(true);
  const successFun = () => {
    const datekey = JSON.parse(localStorage.getItem("user"));
    console.log(datekey);
    // const token = datekey.token;

    setTimeout(() => {
      dispatch(getCartDetails(datekey.token, currentcity && currentcity));
      dispatch(getAllAddress(datekey.token));
      setShowAddressForm(false);
    }, 2000);
  };

  useEffect(() => {
    Scroll();
  }, []);

  const successAdd = () => {
    const datekey = JSON.parse(localStorage.getItem("user"));
    console.log(datekey);
    // const token = datekey.token;

    Scroll();
    setNewName("");
    setPhonenum("");
    setHouseNumber("");
    setstreet_name("");
    setbooking_for("");
    setfinalPin("");
    setpin("");

    dispatch(getCartDetails(datekey.token, currentcity && currentcity));
    dispatch(getAllAddress(datekey.token));
    setShowAddressForm(false);
  };

  const sendId = (values) => {
    setEditId(values.id);
    setShowAddressForm(!showAddressForm);
    console.log(values, "edit id is");
    setNewName(values.name);

    setPhonenum(values.mobile);
    setHouseNumber(values.house_number);
    setstreet_name(values.street_name);
    setbooking_for(values.booking_for);
    setfinalPin(values.areapincode);
    setDeleteId(values.id);
    // areaPincode &&
    //   areaPincode.results &&
    //   areaPincode.results.filter((pincode) => {
    //     setpin(pincode.JSON.parse(pincode) == JSON.parse(values.areaPincode));
    //   });
    // setpin(values.areaPincode)
  };

  const deleteAddressfunction = (id) => {
    console.log("delete id", id);
    const datekey = JSON.parse(localStorage.getItem("user"));
    console.log("data key", datekey.token);
    dispatch(deleteAddress(datekey.token, id, successFun));
    setNewName("");
    setPhonenum("");
    setHouseNumber("");
    setstreet_name("");
    setbooking_for("");
    setfinalPin("");
    setpin("");
  };

  const AddNewAddress = (e) => {
    e.preventDefault();
    setDeleteId("");
    const addressObject = {
      name: newName,
      areapincode: parseInt(finalPin),
      mobile: Phonenum,
      house_number: house_Numbeer,
      street_name,
      booking_for,
    };

    const datakey = JSON.parse(localStorage.getItem("user"));
    const token = datakey.token;

    if (editId !== "") {
      console.log(`address edited with id ${editId}`, addressObject);
      dispatch(editAddressForm(token, addressObject, editId, successFun));
    } else {
      dispatch(postNewAddress(token, addressObject, successAdd));
      console.log("new address added", addressObject);
    }
  };

  const [selectAddress, setAddress] = useState("");

  useEffect(() => {
    localStorage.setItem("addressDetail", JSON.stringify(selectAddress));
    console.log("address ", selectAddress);
  }, [selectAddress]);

  const handleSubmit = () => {
    const datekey = JSON.parse(localStorage.getItem("user"));
    console.log(datekey);

    if (selectAddress == "") {
      alert("please select address");
    } else {
      if (location == "/imagine-patient-Address") {
        history.push({
          pathname: `/imaging/timeSlot`,
          state: coupnDis,
        });
      } else {
        history.push({
          pathname: `/slot`,
          state: coupnDis,
        });
      }
    }
  };

  //on radio change
  const handelRadio = (values) => {
    setAddress(values);
    console.log("values", values);
  };

  //HANDEL PHONE VALIDATION
  const [PhoneError, setPhoneError] = useState("");
  const handelPhoneNumber = (e) => {
    setPhonenum(e.target.value);
    setPhoneError("");
    console.log(e.target.value);
    let phoneno = /^\d{10}$/;
    if (!e.target.value.match(phoneno) || parseInt(Phonenum[0]) < 6) {
      setPhoneError("Enter a valid number");
    } else if (Phonenum > 7) {
      setPhoneError("");
    } else {
      setPhoneError("");
    }
  };
  //HANDEL NAME VALIDATION
  const [NameEror, setNameEror] = useState("");
  const handelName = (e) => {
    setNewName(e.target.value);
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };

  const [disable, setDisable] = useState("");

  useEffect(() => {
    if (NameEror !== "" || PhoneError !== "") {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [NameEror, PhoneError]);
  return (
    <>
      {/* <TopNav isImagine={true} /> */}
      <ImagingNewHeader />

      <BackToscreenIcon
        title={deleteid && deleteid ? "Edit Address" : "Add Address"}
        currpath="imagine-patient-Address"
      />
      <div className="container">
        <DesktopBack
          title={deleteid && deleteid ? "Edit Address" : "Add Address"}
          currpath="imagine-patient-Address"
        />
      </div>
      <div className="planAddDiv">
        <div className="leftSIde">
          {/* <div className="AddressHeaindg">
            <span className="leftArrow">
              <AiOutlineArrowLeft />
            </span>{" "}
            Add Address
          </div> */}
          <div className="warning">
            <AiFillInfoCircle />
            <span>Sample will be picked from the below address</span>
          </div>
          {/**ADD OR EDIT FORM BELOW */}
          {showAddressForm ? (
            <div className="addressFormDiv">
              <form onSubmit={AddNewAddress}>
                <div className="forBorder">
                  {deleteid == "" ? null : (
                    <div className="deletIcon">
                      <RiDeleteBin6Line
                        className="deletlogo"
                        onClick={() =>
                          deleteAddressfunction(deleteid !== "" && deleteid)
                        }
                      />
                    </div>
                  )}

                  <label className="halfWidthinput">
                    <p>NAME</p>{" "}
                    <input
                      type="text"
                      placeholder="Enter Name"
                      value={newName}
                      required
                      onChange={handelName}
                    ></input>
                    {NameEror == "" ? null : (
                      <span className="error">{NameEror}</span>
                    )}
                  </label>
                  <label className="halfWidthinput">
                    <p>MOBILE NUMBER</p>{" "}
                    <input
                      type="text"
                      required
                      value={Phonenum}
                      onChange={handelPhoneNumber}
                      placeholder="Enter Mobile Number"
                    ></input>
                    {PhoneError == "" ? null : (
                      <span className="error">{PhoneError}</span>
                    )}
                  </label>
                  {/* <label className="halfWidthinput">
                    <p>PIN CODE</p>{" "}
                    <input
                      type="text"
                      placeholder="Enter Pin Code"
                      value={areApin}
                      onChange={handelPincode}
                      required
                    ></input>
                    {areApin && areApin !== "" && pinList && (
                      <div className="pincodeList">
                        {pincodeLoading ? (
                          "loading"
                        ) : (
                          <div>
                            {areaPincode &&
                              areaPincode.results &&
                              areaPincode.results
                                .filter((pin) => {
                                  if (areApin == "") {
                                    return pin;
                                  } else if (
                                    pin.pincode
                                      .toLowerCase()
                                      .includes(areApin.toLowerCase())
                                  ) {
                                    return pin;
                                  }
                                })
                                .map((values, index) => {
                                  if (index < 5) {
                                    return (
                                      <li
                                        key={values.id}
                                        onClick={() =>
                                          handelPincodeList(
                                            values
                                          )
                                        }
                                      >
                                        {values.pincode}
                                      </li>
                                    );
                                  }
                                })}
                          </div>
                        )}
                      </div>
                    )}
                  </label> */}
                  <label className="fullWidthinput">
                    <p>HOUSE/FLAT NUMBER & BUILDING*</p>{" "}
                    <input
                      type="text"
                      value={house_Numbeer}
                      required
                      onChange={(e) => setHouseNumber(e.target.value)}
                      placeholder="Enter House And Building"
                    ></input>
                  </label>
                  <label className="fullWidthinput">
                    <p>STREET NAME</p>{" "}
                    <input
                      type="text"
                      value={street_name}
                      required
                      onChange={(e) => setstreet_name(e.target.value)}
                      placeholder="Enter Street Name Or Landmark"
                    ></input>
                  </label>
                  <label className="halfWidthinput">
                    <p>BOOKING FOR</p>
                    <input
                      type="text"
                      required
                      value={booking_for}
                      onChange={(e) => setbooking_for(e.target.value)}
                      placeholder="Eg. Self, Parents, Children"
                    ></input>
                  </label>
                </div>
                <div className="addressBtn2">
                  <button
                    className={disable ? "disabled" : null}
                    type="submit"
                    disabled={disable ? "disabled" : null}
                  >
                    SAVE ADDRESS
                  </button>
                </div>
              </form>
            </div>
          ) : (
            <div className="addresDetails">
              <div className="addressboxDiv">
                {loading ? (
                  <Loader />
                ) : (
                  addresss &&
                  addresss.results &&
                  addresss.results.map((values, index) => {
                    return (
                      <div className="addressBoxsubDiv">
                        <div className="addressBox1">
                          <p>{values.name ? values.name : "Address"}</p>{" "}
                          <input
                            type="radio"
                            name="address"
                            style={{ width: "2rem", height: "2rem" }}
                            onClick={() => handelRadio(values)}
                          />
                        </div>
                        <div className="addressBox2">
                          <p>
                            {values.house_number + "," + values.street_name}
                          </p>{" "}
                          <div
                            className="editDiv"
                            onClick={() => sendId(values)}
                          >
                            <span className="editLogo">
                              <FiEdit />{" "}
                            </span>{" "}
                            <p>Edit</p>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          )}
          {showAddressForm ? null : (
            <div className="addressBtn">
              <button
                type="submit"
                onClick={() => {
                  setShowAddressForm(!showAddressForm), Scroll();
                }}
              >
                ADD NEW ADDRESS
              </button>
            </div>
          )}
        </div>
        <div className="rightside_section">
          {cartLoading ? (
            <Loader />
          ) : (
            cartDetails &&
            cartDetails.cartDetails &&
            cartDetails.cartDetails[0] &&
            cartDetails.cartDetails[0].product && (
              <div>
                <div className="booking_Razordiv">
                  <div className="topRazor">
                    <p>
                      <span className="textblueBold offerprice">
                        ₹{details !== "" ? offerSum : offerPrice && offerPrice}
                      </span>
                      &nbsp;{" "}
                      <span className="sellingPrice">
                        ₹{details !== "" ? sum : Mrp && Mrp}
                      </span>
                    </p>
                    {/* <span className="btn_neon">Get {discountPercentage}% OFF</span> */}
                    <span className="btn_neon">
                      Get{" "}
                      {details !== ""
                        ? discountPercent
                        : discountPercentage && discountPercentage}
                      % OFF
                    </span>
                  </div>
                  <div className="borderBook" />
                  <div className={showDetails ? "toogleBook" : "height0"}>
                    <div className="priceBreakParent">
                      <span>Home Collection Charges</span>
                      <div className="rightSidediv_booking">
                        {/* <span>₹250</span> */}
                        <span className="textSecondary">FREE</span>
                      </div>
                    </div>
                    <div className="borderBook" />

                    <div className="priceBreakParent">
                      <span>Offer Price</span>
                      <div>
                        {/* <span>₹{packageDetails?.package_price}</span> */}
                        <span>₹ {details !== "" && sum}</span>
                      </div>
                    </div>

                    <div className="priceBreakParent">
                      <span>Delivery Charges</span>
                      <div>
                        <span>₹{deliveryCharges}</span>
                      </div>
                    </div>

                    <div className="priceBreakParent">
                      <span>Discount</span>
                      <div>
                        <span>₹ - {details !== "" && discountSum}</span>
                      </div>
                    </div>

                    {coupnDis > 0 ? (
                      <div className="priceBreakParent">
                        <span className="coupnSpan">Coupon Applied</span>
                        <div>
                          <span>-₹ {coupnDis}</span>
                        </div>
                      </div>
                    ) : null}
                    <div className="borderBook" />
                    <div
                      className="priceBreakParent"
                      style={{
                        fontWeight: " 700",
                        fontSize: "1.8rem",
                        color: "#0a406b",
                      }}
                    >
                      <span>Total Amount</span>
                      <div>
                        <span>
                          ₹{" "}
                          {details !== ""
                            ? offerSum + deliveryCharges - coupnDis
                            : finalPrice && finalPrice}
                        </span>
                      </div>
                    </div>
                  </div>

                  <span className="guidelines">
                    *inclusive of all the taxes, fees and subject to
                    availability
                  </span>
                  <div className="borderBook" />
                  {/* <div
                    className="price_Break"
                    onClick={() => setShowDetails(!showDetails)}
                  >
                    <span className="textSecondary">
                      {" "}
                      {showDetails
                        ? "Hide Price Breakup"
                        : "Show Price Breakup"}{" "}
                    </span>{" "}
                    <FiChevronDown />
                  </div> */}
                </div>

                <div className="booking_Razordiv">
                  <p className="textSecondary note">
                    YOU SAVED Rs. {details !== "" && discountSum + coupnDis} ON
                    THIS BOOKING!
                  </p>
                  {/* <div className="coupnCODE">
        <input placeholder="Enter Coupon Code" />{" "}
        <span className="textpink"> Apply</span>
      </div> */}
                  <span className="add_tocart " onClick={handleSubmit}>
                    {details !== "" && discountSum && "Book Now"}
                  </span>
                </div>
              </div>
            )
          )}
          {/* <BookForm /> */}
        </div>
      </div>

      <ImagingFooter telNumber="898 898 0101" />
      <div className="floatingBooking">
        <div className="border-book">
          <div className="price">
            <span
              style={{
                textDecoration: "line-through",
                color: "gray",
                fontSize: "1.3rem",
              }}
            >
              Rs. {details !== "" ? sum : Mrp && Mrp}
            </span>{" "}
            <span className="PriceColor">
              Rs.
              {details !== ""
                ? offerSum && offerSum < 99
                  ? offerSum + deliveryCharges
                  : offerSum - coupnDis
                : offerPrice}{" "}
              /-
            </span>
          </div>
          <div className="discount">
            <span>
              Get{" "}
              {details !== ""
                ? discountPercent
                : discountPercentage && discountPercentage}
              % OFF
            </span>
          </div>
          <div className="New_bookNow">
            <span onClick={handleSubmit}>BOOK</span>
          </div>
        </div>
      </div>
    </>
  );
}
export default { component: PatientAddress };
